import { clientLanguagesData } from 'Shared/TranslatableTextContent/clientLanguagesData'

export default function validate({ action, defaultLanguage = 'en', setErrors }) {
  const validationErrors = []

  const clientLanguages = clientLanguagesData()
  const defaultLanguageIfMultiple = clientLanguages && Object.keys(clientLanguages).length > 1 ? ` (${clientLanguages[defaultLanguage].name})` : ''

  let actionConfig = action.config || { thankYouSubject: '', thankYouSenderId: '', thankYouEnabled: false }

  if (actionConfig.disableOneOffDonations === true && actionConfig.enableMonthlyDonations === false) {
    validationErrors.push("Donation Form Settings: At least one donation type (one-off or monthly) must be enabled.")
  }

  if (actionConfig.thankYouEnabled) {
    if (!actionConfig.thankYouSenderId || actionConfig.thankYouSenderId === '') {
      validationErrors.push("Donation Thank You Email Settings: No sender is selected")
    }
    // Check subject and body fallbacks are available!
    let subject = action.textContent[defaultLanguage]?.thankYouSubject || actionConfig.thankYouSubject
    if (!subject || subject == '') {
      validationErrors.push(`Donation Thank You Email Settings${defaultLanguageIfMultiple}: No subject is set`)
    }
    let body = action.textContent[defaultLanguage]?.thankYouBody || actionConfig.thankYouBody
    if (!body || body == '') {
      validationErrors.push(`Donation Thank You Email Settings${defaultLanguageIfMultiple}: No body is set`)
    }
  }

  setErrors(_.uniq(validationErrors))
}
